import React from 'react';
import { Box } from '@mui/material';

/**
 * SegmentedControl — the uniform mobile segmented tabs (see MOBILE_PLAN.md §E,
 * mockup screen 9). Grey track, active segment lifts to a white pill with a
 * blue label. Controlled: `value` + `onChange(value)`, `options: [{value,label}]`.
 */
const SegmentedControl = function SegmentedControl({
  value,
  onChange = () => {},
  options = [],
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        gap: '2px',
        p: '4px',
        borderRadius: '14px',
        bgcolor: '#eef1f6',
      }}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <Box
            key={option.value}
            role="button"
            onClick={() => onChange(option.value)}
            sx={{
              flex: 1,
              textAlign: 'center',
              py: '10px',
              borderRadius: '11px',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              color: active ? 'primary.main' : 'greys.secondary',
              bgcolor: active ? '#fff' : 'transparent',
              boxShadow: active ? '0 1px 4px rgba(29,91,157,.2)' : 'none',
            }}
          >
            {option.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default SegmentedControl;
